import SFetch from '@app/utils/sfetch'
import { sfAssistantOverviewUrl } from '@app/application/sf-assistant-checks/utils'
import { onDocumentEvent } from '@app/utils/domHelpers'

const dismissWpaBanner = (e) => {
  e.preventDefault()

  const banner = document.querySelector('[data-behaviour="wpa-banner"]')
  const url = Silverfin.Routes.dismiss_wpa_banner_ledger_path({
    firm_id: Silverfin.currentFirmId,
    company_id: Silverfin.currentCompanyId,
    id: Silverfin.currentLedgerId(),
    _options: true,
  })

  SFetch.json(url, { method: 'POST' }).then(() => {
    banner.style.display = 'none'
  })
}

const redirectFromWpaBanner = (e) => {
  e.preventDefault()

  const href = e.target.getAttribute('href')
  dismissWpaBanner(e)
  window.open(href, '_blank').focus()
}

onDocumentEvent(
  document,
  'click',
  '[data-behaviour="wpa-banner-action"]',
  redirectFromWpaBanner
)

onDocumentEvent(
  document,
  'click',
  '[data-behaviour="wpa-banner-dismiss"]',
  dismissWpaBanner
)

onDomLoad(($dom) => {
  $dom.find('[data-behaviour="wpa-banner-action"]').each(function () {
    const data = this.dataset

    const objectType = data.wpaObjectType
    const objectId = data.wpaObjectId

    this.setAttribute('href', sfAssistantOverviewUrl(objectType, objectId))
  })
})
